/** 解析 16-bit PCM WAV（本项目 gen-sfx 产物），供 iPhone WebAudio 同步解码。 */

export type PcmWav = {
  sampleRate: number;
  channels: number;
  samples: Float32Array[];
};

function readFourCC(view: DataView, offset: number): string {
  return String.fromCharCode(view.getUint8(offset), view.getUint8(offset + 1), view.getUint8(offset + 2), view.getUint8(offset + 3));
}

export function decodePcmWav(data: ArrayBuffer): PcmWav | null {
  if (data.byteLength < 44) return null;
  const view = new DataView(data);
  if (readFourCC(view, 0) !== "RIFF" || readFourCC(view, 8) !== "WAVE") return null;
  let offset = 12;
  let sampleRate = 0;
  let channels = 0;
  let bits = 0;
  let pcm = false;
  let samples: Float32Array[] | null = null;
  while (offset + 8 <= view.byteLength) {
    const id = readFourCC(view, offset);
    const size = view.getUint32(offset + 4, true);
    const start = offset + 8;
    if (start + size > view.byteLength) break;
    if (id === "fmt ") {
      const format = view.getUint16(start, true);
      channels = view.getUint16(start + 2, true);
      sampleRate = view.getUint32(start + 4, true);
      bits = view.getUint16(start + 14, true);
      pcm = format === 1;
    } else if (id === "data" && pcm && bits === 16 && channels >= 1 && channels <= 2 && sampleRate > 0) {
      const count = Math.floor(size / 2 / channels);
      samples = [];
      for (let c = 0; c < channels; c++) samples.push(new Float32Array(count));
      let i = 0;
      for (let f = 0; f < count; f++) {
        for (let c = 0; c < channels; c++) {
          const s = view.getInt16(start + i, true);
          i += 2;
          samples[c]![f] = s / 32768;
        }
      }
      break;
    }
    offset = start + size + (size % 2);
  }
  if (!samples || !sampleRate || !channels) return null;
  return { sampleRate, channels, samples };
}

export function pcmWavToAudioBuffer(ctx: AudioContext, data: ArrayBuffer): AudioBuffer | null {
  const wav = decodePcmWav(data);
  if (!wav) return null;
  try {
    const frames = wav.samples[0]?.length ?? 0;
    const buf = ctx.createBuffer(wav.channels, frames, wav.sampleRate);
    for (let c = 0; c < wav.channels; c++) {
      const src = wav.samples[c];
      if (!src) continue;
      buf.getChannelData(c).set(src);
    }
    return buf;
  } catch {
    return null;
  }
}
